import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { GiftService } from './gift.service';
import { UIRouter } from '@uirouter/core';
import { Subscription } from 'rxjs';
import { ButtonModel } from '../../buttons/models/button.model';
import { ButtonsService } from '../../buttons/buttons.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  templateUrl: './gift.component.html',
  styleUrls: [
    './gift.component.scss'
  ]
})
export class GiftComponent implements OnInit, OnDestroy {
  @Input()
  public stateParams: { code: string };
  public button: Object;
  public videoButtonsHtml: SafeHtml;
  public multipleButtonsImagePath: string = '/assets/img/multiple_buttons_video_fallback5_no_bg.png';
  public showMultipleButtonsVideo: boolean = false;
  private voucherCode: string;
  private voucherCheckSubscription: Subscription;
  private videoRoot: string = 'https://d3l6ptb89vyf3h.cloudfront.net/videos';
  
  constructor(
    private router: UIRouter,
    private giftService: GiftService,
    private buttonsService: ButtonsService,
    private domSanitizer: DomSanitizer
  ) { }
  
  public ngOnInit() {
    this.voucherCode = this.stateParams.code;
    
    this.videoButtonsHtml = this.domSanitizer.bypassSecurityTrustHtml(`<video playsinline muted="muted" id="video3" class="Video" poster="/assets/img/multiple_buttons_video_fallback5.png" autoplay="autoplay" loop="loop">
        <source src="${this.videoRoot}/no_audio_1_bg_holeknopf_large.mp4" type="video/mp4" />
        <source src="${this.videoRoot}/no_audio_1_bg_holeknopf_large.webm" type="video/webm" />
      </video>`);
    
    this.voucherCheckSubscription = this.giftService.voucherCheck(this.voucherCode)
    .subscribe((result) => {
      if (!result.isValid) {
        this.router.stateService.go('main.checkout.index', { code: this.voucherCode });
      } else if (result.isValid) {
        let buttonData = {
          design: result.button.design,
          spiritual: result.button.spiritual,
          code: result.code,
          value: result.button.value
        };
        
        this.button = this.buttonsService.factory(buttonData);
      }
    });
  }
  
  public ngOnDestroy() {
    this.voucherCheckSubscription.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/microsites/gift/gift.component.ts